import MomentumSlider from 'momentum-slider';
import { debounce } from 'debounce';
import * as React from 'react';
import { i18n } from '../../../i18n';

class Timeframe extends React.Component {
  componentDidMount() {
    const durationRangeFrom = 1;
    const durationRangeTo = 40;

    // Initialize plugin
    this.momentumSlider = new MomentumSlider({
      currentIndex: this.props.duration - 1,
      el: this.refs.momentumSlider,
      multiplier: 2,
      range: [durationRangeFrom, durationRangeTo],
      style: {
        opacity: [0.3, 1],
        transform: [{scale: [0.4, 1]}],
      }
    });

    // As the slider moves, the exact position/index gets passed to this event
    this.momentumSlider.onChangeCurrentIndex = debounce((movingIndex) => {
      let targetDuration = movingIndex + 1;

      // Due to the nature of this plugin, if the slider moves quickly
      // then the index can go out of bounds because of the bouncing
      if(targetDuration < durationRangeFrom) {
        targetDuration = 1;
      } else if(targetDuration > durationRangeTo) {
        targetDuration = 40;
      }

      // Set new duration if targetDuration is different
      if(this.props.duration !== targetDuration) {
        this.props.setDuration(targetDuration);
      }
    }, 200);
  }

  render() {
    return (
      <div className='timeframe-wrap'>
        <div className='years-list-wrap'>
          <div className='marker marker-top' />
          <div className='ms-slider' ref='momentumSlider' />
          <span>{i18n.t('tool.inv_timeframe.years')}</span>
          <div className='marker marker-bottom' />
        </div>
        <p>{i18n.t('tool.inv_timeframe.instructions')}</p>
      </div>
    );
  }
}

export default Timeframe;
